import 'reflect-metadata';
import {jsonObject, jsonMember, jsonArrayMember} from 'typedjson';

@jsonObject
export class LoraPacketForwarderStats {
  @jsonMember public UpstreamPacketsReceivedChecksumValid: number = 0;
  @jsonMember public UpstreamPacketsReceivedChecksumWrong: number = 0;
  @jsonMember public UpstreamPacketsReceivedChecksumMissing: number = 0;

  @jsonMember public UpstreamPacketsForwarded: number = 0;
  @jsonMember public UpstreamPacketsForwardedSize: number = 0;

  @jsonMember public UpstreamDatagramsSent: number = 0;
  @jsonMember public UpstreamDatagramsSentSize: number = 0;
  @jsonMember public UpstreamDatagramsSentAck: number = 0;

  @jsonMember public DownstreamDataRequestsSent: number = 0;
  @jsonMember public DownstreamDataRequestsSentAck: number = 0;
  @jsonMember public DownstreamDataRequestsResponded: number = 0;
  @jsonMember public DownstreamDataRequestsRespondedSize: number = 0;

  @jsonMember public DownstreamPacketsSent: number = 0;
  @jsonMember public DownstreamPacketsSentSize: number = 0;

  @jsonMember public BeaconSent: number = 0;
  @jsonMember public TxErrors: number = 0;
  @jsonMember public BeaconQueued: number = 0;
  @jsonMember public BeaconRejected: number = 0;

  public get UpstreamPacketsReceived(): number {
    return this.UpstreamPacketsReceivedChecksumValid + this.UpstreamPacketsReceivedChecksumWrong + this.UpstreamPacketsReceivedChecksumMissing;
  }

  public get UpstreamPacketsReceivedChecksumValidRatio(): number {
    return this.UpstreamPacketsReceivedChecksumValid / this.UpstreamPacketsReceived * 100;
  }

  public get UpstreamPacketsReceivedChecksumWrongRatio(): number {
    return this.UpstreamPacketsReceivedChecksumWrong / this.UpstreamPacketsReceived * 100;
  }

  public get UpstreamPacketsReceivedChecksumMissingRatio(): number {
    return this.UpstreamPacketsReceivedChecksumMissing / this.UpstreamPacketsReceived * 100;
  }

  public get UpstreamDatagramsSentAckRatio(): number {
    return this.UpstreamDatagramsSentAck / this.UpstreamDatagramsSent * 100;
  }

  public get DownstreamDataRequestsSentAckRatio(): number {
    return this.DownstreamDataRequestsSentAck / this.DownstreamDataRequestsSent * 100;
  }
}
